import { render, staticRenderFns } from "./ProposteSoggiorno.vue?vue&type=template&id=bae6f6ee&"
import script from "./ProposteSoggiorno.vue?vue&type=script&lang=js&"
export * from "./ProposteSoggiorno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports